import cn from 'classnames';
import config from '@creditflowresearch/config';
import { CreditflowresearchTenant } from '@/creditflowresearch/domain/vo/types/CreditflowresearchTenant';
import BookDemoButton from '@framework/ui/Organisms/ScheduleDemo/ScheduleDemoModal/BookDemoButton';
import { LogoCreditFlowResearchStandart } from '@creditflowresearch/uilib/Logo/CreditFlowResearch/Standart';
import { useBookDemo } from '@/creditflowresearch/ui/common/components/atoms/BookDemoButton';

import styles from './bookDemoButton.module.scss';

const BookDemoCfrButton = ({ className, dataTest }: { className?: string, dataTest?: string }) => {
  const openBookDemo = useBookDemo();

  return (
    <BookDemoButton
      tenant={ config.code as CreditflowresearchTenant }
      logoComponent={ LogoCreditFlowResearchStandart }
      className={ cn(styles.button, className) }
      title="Book Demo"
      openModalWithUrl={ openBookDemo }
      dataTest={ dataTest }
    />
  );
};

export default BookDemoCfrButton;
